module.exports = __webpack_public_path__ + "cc96f03ead2e31233eee7557cd3c908d.png";